export const GET_TASK_ROUTE_START = 'GET_TASK_ROUTE_START';
export const RESET_TASK_ROUTE = 'RESET_TASK_ROUTE';
export const GET_TASK_ROUTE_SUCCESS = 'GET_TASK_ROUTE_SUCCESS';
export const GET_TASK_ROUTE_FAILURE = 'GET_TASK_ROUTE_FAILURE';
export const UPDATE_TASK_ROUTE = 'UPDATE_TASK_ROUTE';
